"use client";
import React, { useState } from "react";
import { Accordion, AccordionItem, Button } from "@nextui-org/react";
import { ContentContainer, Layout, Stack } from "../molecules";
import FaqIcon from "../../assets/svg/FaqIcon";
import { useDictionary } from "../../context/dictionaryProvider";
import Editor from "../molecules/Editor";
import { ChevronDownIcon, MaximizeIcon, ChevronUpIcon } from "../../assets/svg";

const BaseAccordion = ({
  title,
  blogDataDiv,
  blogDataTitle,
  space,
  itemsDiv,
  arrowIcon,
  containerSpace,
  showExpandTable = false,
  data = [],
  showHeaderIcon = true,
  onToggle,
}) => {
  const dict = useDictionary();
  const [isDataVisible, setIsDataVisible] = useState(!showExpandTable);
  const [isExpanded, setIsExpanded] = useState(false);
  const handleLoadMore = () => {
    setIsExpanded(true);
  };

  const handleLoadLess = () => {
    setIsExpanded(false);
  };
  const accordianDataList = isExpanded ? data : data.slice(0, 4);
  const handleToggle = () => {
    setIsDataVisible((prevState) => !prevState);
    if (onToggle) {
      onToggle(!isDataVisible);
    }
  };

  return (
    <Layout className="accordion">
      <ContentContainer className={`${containerSpace ? containerSpace : ""}`}>
        <Stack
          className={`${blogDataDiv ? blogDataDiv : "flex items-center gap-4 mx-auto mb-20"}`}
          // style={{ flexDirection: "column" }}
        >
          {showHeaderIcon && <FaqIcon />}
          <h2
            className={`${
              blogDataTitle
                ? blogDataTitle
                : "text-3xl lg:text-[40px] font-extrabold leading-normal"
            }`}
          >
            {title || dict?.faqs.title}
          </h2>
          {showExpandTable && (
            <div
              className="relative cursor-pointer"
              onClick={handleToggle}
            >
              <MaximizeIcon />
            </div>
          )}
        </Stack>
        {isDataVisible && (
          <div
            className={`overflow-hidden h-full transition-max-height ease-linear duration-500 ${
              isExpanded
                ? "overflow-y-scroll max-h-[34rem] ease-in"
                : "overflow-y-hidden max-h-[32rem] ease-out"
            }`}
          >
            <Accordion
              className={`${space ? space : ""}`}
              defaultExpandedKeys={["0"]}
            >
              {accordianDataList?.map((item, index) => (
                <AccordionItem
                  key={index}
                  aria-label={item?.title}
                  title={<h3>{item?.title}</h3>}
                  className={`${
                    itemsDiv
                      ? itemsDiv
                      : "transition-all duration-500 ease-in-out border-b-1 border-b-[#DFDFDF]"
                  }`}
                  indicator={({ isOpen }) =>
                    isOpen ? (
                      <ChevronUpIcon
                        className={`${arrowIcon ? arrowIcon : ""}`}
                      />
                    ) : (
                      <ChevronDownIcon
                        className={`${arrowIcon ? arrowIcon : ""}`}
                      />
                    )
                  }
                  classNames={{
                    title: "font-semibold text-base",
                    content:
                      "font-normal text-sm transition-all duration-500 ease-in-out",
                  }}
                  disableIndicatorAnimation={true}
                >
                  {item?.description && <Editor content={item?.description} />}
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        )}
        <div className="flex justify-center">
          {!isExpanded && data.length > 4 && (
            <Button
              onClick={handleLoadMore}
              className="primaryLinkTxt flex gap-4 items-center justify-center mt-6 underline underline-offset-4 text-[#0096AC] bg-transparent"
            >
              {dict?.readMore}
            </Button>
          )}
          {isExpanded && (
            <Button
              className="primaryLinkTxt flex gap-4 items-center justify-center mt-6 underline underline-offset-4 text-[#0096AC] bg-transparent"
              onClick={handleLoadLess}
            >
              {dict?.readLess}
            </Button>
          )}
        </div>
      </ContentContainer>
    </Layout>
  );
};

export default BaseAccordion;
